<template>
  <div class="hello">
    <div class="haeder">
        <img style="width: 13%;height:auto;" src="../assets//logo_1.jpg"></img>
        <div style="width: 50%;display: flex;justify-content: space-between;">
          <div
            class="tab"
            v-for="(tab, index) in tabs"
            :key="index"
            @click="tabChange(index)"
            :class="{'active': selectedIndex === index}"
          >
            {{ tab }}
          </div>
        </div>
        <!-- <el-button class="btn1">免费试用</el-button> -->
        <el-button class="btn2" @click="goToBaidu">系统登录</el-button>
    </div>
    <div style="height: 90px;"></div>
    <div class="body1" v-show="selectedIndex==0">
      <div style="width: 100%;height: auto;margin: 0 auto;">
        <img style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%204.png">
      </div>
      <div style="width: 100%;height: auto;margin: 0 auto;box-sizing: border-box;">
        <img  style="width: 85%;height: auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%205.jpg">
      </div>
      
      <div style="width: 100%;height: auto;margin: 0 auto;">
        <img  style="width: 80%;height: auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%206.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;position: relative;background-image:url('https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-31.jpg')" >
        <img  style="width: 80%;height: auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%207.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;position: relative;" >
        <img  style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%208.jpg">
      </div>
    </div>
    <div class="body2" v-show="selectedIndex==1">
      <div style="width: 100%;height: auto;margin: 0 auto;">
        <img style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2010.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2011.png">

        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2012.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2013.png">

        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2014.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2015.png">

        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2016.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2017.png">

        <img style="width: 28%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fqym%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2018.png">
      </div>
      <div style="width: 100%;height: auto;margin: 0 auto;">
        <img style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%207.png">
      </div>
    </div>

    <div class="body3" v-show="selectedIndex==2">
      <div style="width: 100%;height: auto;margin: 0 auto;position: relative;" >
        <img  style="width: 100%;height:auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%202.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-20.png">

        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-21.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-22.png">

        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-23.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-24.png">

        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-25.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-26.png">

        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-27.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;display: flex;">
        <img style="width: 30%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-28.png">

        <img style="width: 40%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fls%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91-29.png">
      </div>

      <div style="width: 100%;height: auto;margin: 0 auto;">
        <img style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%207.png">
      </div>

    </div>

    <div class="body4" v-show="selectedIndex==3">
      <div style="width: 100%;height: auto;margin: 0 auto;position: relative;" >
        <!-- <img  style="width: 80%;height:auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240625111732.png"> -->
        <img  style="width: 80%;height:auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.cos.ap-shanghai.myqcloud.com/YmyImg%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240815153020.png">
      </div>
      <div style="width: 100%;height: auto;margin: 0 auto;">
        <img style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%207.png">
      </div>
    </div>

    <!-- <div style="width: 100%;height: auto;margin: 0 auto;position: relative;background: black;" >
        <img  style="width: 100%;height:auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%209.jpg">
        <div style="position: absolute;top: 80%;left: 7.8%;">
          <img src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2Fbeian_icon.png" >
          <a style="color: #fff;margin-left: 10px;text-decoration: none;" href="https://beian.mps.gov.cn/#/query/webSearch?code=32059002005269" class="a_tiao" rel="noreferrer" target="_blank">苏公网安备32059002005269</a>
					<a class="a_tiao" style="color: #fff;margin-left: 10px;text-decoration: none;" target="_blank" href="https://beian.miit.gov.cn">苏ICP备2024100884号-1</a>
        </div>
        
    </div> -->
    <div class="bg-black">
      <div class="text-lg-center">
        <div style="display: flex;flex-direction: column;align-items: center;">
          <img style="width: 40px;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%209.png">
          <span style="margin-top: 10px;">包落地上线</span>
          <span>包使用培训</span>
        </div>

        <div style="display: flex;flex-direction: column;align-items: center;text-align: center;">
          <img style="width: 40px;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2010.png">
          <span style="margin-top: 10px;">360天服务支持</span>
          <span>（含周末节假日）</span>
        </div>

        <div style="display: flex;flex-direction: column;align-items: center;text-align: center;">
          <img style="width: 40px;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2011.png">
          <span style="margin-top: 10px;">1V1在线支持</span>
        </div>

        <div style="display: flex;flex-direction: column;align-items: center;text-align: center;">
          <img style="width: 40px;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2012.png">
          <span style="margin-top: 10px;">历史顾客数据迁移</span>
        </div>

      </div>

      <div class="text-lg-center2">
        <div style="width: 30%;display: flex;flex-direction: column;">
          苏州青嵩网络科技有限公司
          <p style="color: #FFFFFFBF;">公司核心人员有着超10年的美业或互联网工作经验,本着成为“客户能成功,我们才能存活”的经营理念,我们不炒概念、不追风口,以“极致好用”为目标,重视每个客户在使用中的问题,快速迭代系统,踏踏实实做好美业信息系统平台。</p>
        </div>
        <div style="width: 20%;display: flex;justify-content: space-between;">
          <span>生美/双美</span>
          <span>医美/连锁</span>
          <span>版本功能</span>
        </div>

        <div style="width: 20%;display: flex;flex-direction: column;">
          <span style="font-size: 28px;margin-top: -5px;">153-0060-8364</span>
          <span style="color: #FFFFFFBF;margin-top: 15px;margin-left: 8px;">周一到周日9:00-19:00</span>
          <div style="height: 20%;border: 1px solid #FFFFFFBF;height: 39px;border-radius: 4px;color: #FFFFFFBF;text-align: center;display: flex;align-items: center;justify-content: center;margin-top: 15px;margin-left: 8px;">
            <img style="width: 20px;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%2013.png">
            <span style="margin-left: 10px;">7*12小时为您服务</span>
          </div>
        </div>
      </div>

      <div style="width: 400px;margin: 0 auto;">
          <img style="width: 17px;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2Fbeian_icon.png" >
          <a style="margin-left: 10px;text-decoration: none;color: #FFFFFFBF;" href="https://beian.mps.gov.cn/#/query/webSearch?code=32059002005269" class="a_tiao" rel="noreferrer" target="_blank">苏公网安备32059002005269</a>
					<a class="a_tiao" style="margin-left: 10px;text-decoration: none;color: #FFFFFFBF;" target="_blank" href="https://beian.miit.gov.cn">苏ICP备2024100884号-1</a>
      </div>
      

    </div>

    <div class="mei-top-btns">
        <div class="iphone" style="border-top-left-radius: 10px ;" @mouseenter="showExtra = true" @mouseleave="showExtra = false">
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img style="height: auto;width:30px ;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2Fslider_follow.png">
            <span>免费试用</span>
          </div>
          <transition name="slide">
            <div v-if="showExtra" class="sliding-div">153-0060-8364</div>
          </transition>
        </div>
        <div style="width: 50px;border: 0.5px solid #e5dfe7;margin: 0 auto;"></div>
        <div class="iphone" @mouseenter="showExtraT = true" @mouseleave="showExtraT = false">
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img style="height: auto;width:30px ;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2Fslider_query.png">
            <span>微信联系</span>
          </div>
          <transition name="slide">
            <div v-if="showExtraT" class="sliding-div_vx" style="display: flex;align-items: center;justify-content: center;">
              <img style="height: auto;width: 100px;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240624173248.jpg">
            </div>
          </transition>
        </div>
        <div style="width: 50px;border: 0.5px solid #e5dfe7;margin: 0 auto;"></div>
        <div class="iphone" style="border-bottom-left-radius: 10px;" @mouseenter="show = true" @mouseleave="show = false">
         
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img style="height: auto;width:30px ;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2Fslider_download.png">
            <span>电话咨询</span>
          </div>
          <transition name="slide">
            <div v-if="show" class="sliding-div">153-0060-8364</div>
          </transition>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
      return {
        selectedIndex: 0,
        activeName: 'second',
        tabs:['首页','生美/轻医美','医美/连锁','版本功能'],
        isSticky: false,
        stickyOffset: 0,
        stickyTop:0,
        showExtra: false,
        show: false,
        showExtraT:false
      };
    },
  
  props: {
    msg: String
  },
  
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
      tabChange(index) {
        this.selectedIndex=index
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
    //   handleScroll() {
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   if (scrollTop > this.stickyTop) {
    //     this.isSticky = true;
    //   } else {
    //     this.isSticky = false;
    //   }
    // },
    goToBaidu() {
      // 使用window.location.href或window.open跳转
      // window.location.href = 'https://www.baidu.com';
      window.open('http://saas.ymeicloud.com/');
    }
  },

  

}
</script>
<style scoped>
  ::v-deep .el-tabs__nav-wrap::after {
    height: 0px;
  }
  .hello{
    min-height: 600px;
    /* background:palegreen; */
    position: relative;
  }
  .sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }
  .haeder{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display:flex;
    justify-content: space-between;
    background: #fff;
    box-sizing: border-box;
    padding: 0 130px;
    align-items: center;
    z-index: 1000;
    height: 90px;
    border-bottom: 1px solid 	#e5dfe7 !important;
  }
  .haeder .tab {
    cursor: pointer;
  }
  .haeder .active {
    /* font-weight: bold; */
    border-bottom: 3px solid #9932CC;
  }
  .tab{
      text-align: center;
      width: 100px;
      height: 50px;
      line-height: 50px;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  
  .haeder .btn1{
    background: #9932CC;
    color: #fff;
    width: 130px;
    height: 40px;
    border-radius: 5px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  .haeder .btn2{
    background: #9932CC;
    color: #fff;
    width: 130px;
    height: 40px;
    border-radius: 5px;
    margin-right: 70px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  .fade-enter-active, .fade-leave-active {
    transition: transform .5s ease-in-out;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }

  .body1{
    margin-top: 10px;
  }

  .body2{
    margin-top: 10px;
  }

  .body3{
    margin-top: 10px;
  }

  .body4{
    margin-top: 10px;
  }
  
  .a_tiao{
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
  }

  .bg-black {
    width: 100%;
    height: 475px;
    background-color: #000000;
    margin: 0 auto;
    
  }

  .text-lg-center{
    color: #fff;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    padding-bottom: 2rem !important;
    padding-top: 2rem !important;
    border-bottom: 1px solid #FFFFFFBF;
  }

  .text-lg-center2{
    color: #fff;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 16px;
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
    padding-bottom: 3rem !important;
    box-sizing: border-box;
    padding: 0 50px;
  }


  .mei-top-btns {
    position: fixed;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    width: 86px;
    height: 330px;
    z-index: 10;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 .5rem 1rem #00000026!important
}

.iphone{
  /* position: relative; */
  height: 110px;
  background: #fff;
  text-align: center;
  /* line-height: 50px; */
  z-index: 99 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border-radius: 10px; */
  font-size: 15px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  cursor: pointer;
  
}


.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
  transform: translateX(100%);
}
.iphone >.sliding-div {
  position: absolute;
  right: 90px;
  height: 50px;
  line-height: 50px;
  width: 190px;
  border-radius: 10px;
  background: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  z-index: -1 !important;
  color: #9932CC;
}


.sliding-div_vx{
  position: absolute;
  right: 90px;
  height: 120px;
  width: 120px;
  background: #fff;
  z-index: -1 !important;
}
  
</style>
